// extracted by mini-css-extract-plugin
export var sponsors = "sponsors--sponsors--ZLNHh";
export var sponsors__wrapper = "sponsors--sponsors__wrapper--NF283";